import { createActivitiesApi } from '@d-orca/shared/client/apis';
import { authedFetch } from '@apis/auth';

// The Activities & Issues page's committed-activity feed and the commit form's
// assignee list. The HTTP shapes live in the shared client so mobile reads the
// same contract; this only binds them to the web app's authed transport.

export type { ICommittedActivity, ICommitAssignee } from '@d-orca/shared/client/apis';

export const { fetchCommittedActivities, fetchCommitAssignees } = createActivitiesApi(authedFetch);
